import React, { useState, useEffect } from "react";
import { AllSensorsDataContext } from "./context";

import { getAllSensorsData, getMoreAllSensors } from "../services/services";

const AllSensorsProvider = ({ children }) => {
  const [allSensorsData, setAllSensorsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllSensors = async () => {
      const AllSensors = await getAllSensorsData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
          return [];
        });

      const tempAllSensors = {};

      for (let sensor of AllSensors) {
        if (tempAllSensors[sensor.sensortype_id] === undefined) {
          tempAllSensors[sensor.sensortype_id] = { data: [], filters: [] };
          // tempAllSensors[sensor.sensortype_id] = [];
        }
        tempAllSensors[sensor.sensortype_id].data.push(sensor);
      }

      const getMoreSensors = await getMoreAllSensors()
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
          return [];
        });

      const wifiHotSpots = getMoreSensors.filter(
        (sensor) => sensor.sensortype_id === "4"
      );

      const pointsOfInterest = getMoreSensors.filter(
        (sensor) => sensor.sensortype_id === "7"
      );

      const benches = getMoreSensors.filter(
        (sensor) => sensor.sensortype_id === "30"
      );

      tempAllSensors["4"] = wifiHotSpots;
      tempAllSensors["7"] = pointsOfInterest;
      tempAllSensors["30"] = benches;

      tempAllSensors["31"]?.data.sort(
        (a, b) =>
          parseInt(a.mysensor_name.substring(22)) -
          parseInt(b.mysensor_name.substring(22))
      );

      console.log("TEST: all sensors:", tempAllSensors);

      setAllSensorsData(tempAllSensors);
    };

    fetchAllSensors();
  }, []);

  return (
    <AllSensorsDataContext.Provider
      value={{
        allSensorsData,
        setAllSensorsData,
        loading,
        error,
      }}
    >
      {children}
    </AllSensorsDataContext.Provider>
  );
};

export default AllSensorsProvider;
